import { inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class InfoService {
  public statusUpdated: Subject<string> = new Subject<string>();

  private translate = inject(TranslateService);

  public clearStatus() {
    this.statusUpdated.next('');
  }

  public setStatus(status: string) {
    this.statusUpdated.next(status);
  }

  public setStatusTranslate(toTranslate: string) {
    this.setStatus(this.translate.instant(toTranslate));
  }

  public setLoadedItems(count: number) {
    this.statusUpdated.next(this.translate.instant('INFO.ITEMSLOADED', { value: count }));
  }
}
